export type LocationId = "driggs" | "victor";

export type RestaurantLocation = {
  id: LocationId;
  officialName: string;
  shortName: string;
  address: string;
  phone: string;
  phoneHref: string;
  pagePath: string;
  menuPath: string;
  directionsUrl: string;
  orderUrl: string | null;
  hours: string[];
  reviewUrl: string | null;
  socialLinks: string[];
  coordinates: { latitude: number; longitude: number } | null;
};

export const restaurantHours = [
  "Monday: 11:00 AM–9:30 PM",
  "Tuesday: 11:00 AM–9:30 PM",
  "Wednesday: 11:00 AM–9:30 PM",
  "Thursday: 11:00 AM–12:00 AM",
  "Friday: 12:00 AM–9:30 AM, 11:00 AM–9:30 PM",
  "Saturday: 11:00 AM–9:30 PM",
  "Sunday: 11:00 AM–9:30 PM",
];

export const locations: Record<LocationId, RestaurantLocation> = {
  driggs: {
    id: "driggs",
    officialName: "Agave Family Mexican Restaurant",
    shortName: "Agave Driggs",
    address: "310 North Main Street, Driggs, ID 83422",
    phone: "(208) 354-2003",
    phoneHref: "tel:+12083542003",
    pagePath: "/driggs",
    menuPath: "/menus/driggs",
    directionsUrl: "https://www.google.com/maps/dir/?api=1&destination=310%20North%20Main%20Street%2C%20Driggs%2C%20ID%2083422",
    orderUrl: null,
    hours: restaurantHours,
    reviewUrl: null,
    socialLinks: [],
    coordinates: null,
  },
  victor: {
    id: "victor",
    officialName: "Blue Agave",
    shortName: "Blue Agave Victor",
    address: "31 West Center Street, Victor, ID 83455",
    phone: "(208) 787-3333",
    phoneHref: "tel:+12087873333",
    pagePath: "/victor",
    menuPath: "/menus/victor",
    directionsUrl: "https://www.google.com/maps/dir/?api=1&destination=31%20West%20Center%20Street%2C%20Victor%2C%20ID%2083455",
    orderUrl: null,
    hours: restaurantHours,
    reviewUrl: null,
    socialLinks: [],
    coordinates: null,
  },
};

export const ownerContentChecklist = [
  "Online ordering URL for each location",
  "Google review URL for each location",
  "Map coordinates for each location",
  "Reservation provider URLs, if offered",
  "Verified social profile URLs",
  "Current event dates, times, details, and cover charges",
  "Real location-specific reviews and rating counts",
  "Real Driggs and Victor gallery photography",
  "Menu descriptions, Spanish dish names, availability, and verified dietary labels",
  "Which sides are available at each location",
  "Newsletter provider and consent storage",
  "Catering and private-event form destination",
  "Verified price range and additional Restaurant schema fields",
  "Gift card and careers links, if they exist",
];
